import React, { useState } from 'react';

// admin#175 — revoking a partner client is permanent (a revoked client cannot
// be reactivated), so the admin has to type the client's name to confirm.
function ConfirmRevokeModal({ client, busy, onConfirm, onCancel }) {
    const [typed, setTyped] = useState('');
    const matches = typed.trim() === client.name;

    return (
        <>
            <div className="modal d-block" tabIndex="-1" role="dialog" aria-modal="true" aria-labelledby="confirm-revoke-title">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="confirm-revoke-title">Revoke client</h5>
                            <button type="button" className="close" aria-label="Close" onClick={onCancel} disabled={busy}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body txt_lft">
                            <p>
                                <strong>{client.name}</strong> (<code>{client.clientId}</code>) will stop working within
                                about a minute. This can&apos;t be undone; the partner would need a new registration.
                            </p>
                            <label htmlFor="confirm-revoke-name">
                                Type <strong>{client.name}</strong> to confirm
                            </label>
                            <input
                                id="confirm-revoke-name"
                                className="form-control"
                                value={typed}
                                onChange={(e) => setTyped(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={busy}>
                                Cancel
                            </button>
                            <button type="button" className="btn btn-danger" disabled={!matches || busy} onClick={onConfirm}>
                                Revoke
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" />
        </>
    );
}

export default ConfirmRevokeModal;
